export default __webpack_public_path__ + "static/media/weblogo.c451c6fb.png";